export const ACTIVITY_TYPES = [
  'Fixed',
  'FlexEvent',
  'Repetitive',
  'Tour',
  'DutchAuction',
  'Quiz',
];

export const SHOPPING_CONTAINER = {
  ShoppingCart: -2,
  NewShoppingList: -1,
};
